import Vue from 'vue';
import Vuex from 'vuex';

// TODO: przeniesc tutaj wszystkie obiekty source
// TODO: zapytania GET chyba nie potrzebują wczesniejszego wywołania tokena z sanctum-a
// TODO: ułożyć w odpowiedniej kolejności metody i zmienne

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        validation: {
            message: null,
            errors: {}
        },
        snackbar: {
            show: false,
            color: null,
            message: null,
        },
        sources: {
            load_orders: null,
            load_give_outs: null,
            update_give_out_shipment: null,
            load_drafts: null,
            load_systems: null,
            get_draft: null,
            destroy_draft: null,
            draft_store: null,
            delete_drafted_block: null,
            update_draft_customer: null,
            order_show: null,
            order_store: null,
            order_update: null,
            order_delete: null,

            order_closed_index: null,
            order_closed_show: null,

            load_system_blocks: null,
            load_block_colors: null,
            load_block_front_colors: null,
            block_component_index: null,
            block_component_color_index: null,

            store_drafted_blocks: null,
            shipment_type_index: null,

            reclamation_index: null,
            reclamation_store: null,
            reclamation_update: null,
            reclamation_delete: null,

            token_index: null,
            token_store: null,
            token_delete: null,

            reclamation_reason_index: null,

            client_show: null,
            client_update: null,
            client_detail_update: null,
            client_password_update: null,
            client_system_destroy: null,
            invited_client_store: null,

            country_index: null,
            providence_index: null,
            city_index: null,

            active_message_index: null,
            message_index: null,
            message_store: null,
            message_update: null,
            message_delete: null,

            tag_index: null,
            tag_store: null,
            tag_update: null,
            tag_delete: null,

            system_image_store: null,
            system_image_delete: null,

            system_client_store: null,

            block_index: null,
            block_instruction_store: null,
            block_instruction_delete: null,
            block_update: null,

            package_index: null,
            package_update: null,
            package_image_store: null,
            package_image_delete: null,
            package_default_image_update: null,
            package_stock_levels_export: null,

            color_index: null,
            color_image_store: null,
            color_image_delete: null,

            distributor_index: null,

            client_index: null,

            web_app_user_email_update: null,
            web_app_user_delete: null,

            unit_index: null,
            unit_availability_date_update: null,
            unit_availability_date_bulk_update: null,

            user_index: null,
            user_qr_code_index: null,
            user_store: null,
            user_show: null,
            user_update: null,
            user_password_update: null,
            user_destroy: null,
            user_role_index: null,
        },
        footerHeight: 0,
    },

    getters: {
        hasValidationError: (state) => (name) => state.validation.errors.hasOwnProperty(name),

        validationError: (state, getters) => (name) => getters.hasValidationError(name)
            ? state.validation.errors[name][0]
            : null,
    },

    mutations: {
        showSnackbarError(state, message) {
            state.snackbar.color = 'error';
            state.snackbar.message = message;
            state.snackbar.show = true;
        },
        showSnackbarSuccess(state, message) {
            state.snackbar.color = 'success';
            state.snackbar.message = message;
            state.snackbar.show = true;
        },
        closeSnackbarMessage(state) {
            state.snackbar.show = false;
        },
        setValidationErrors(state, errors) {
            state.validation.errors = errors;
        },
        setValidationMessage(state, message) {
            state.validation.message = message;
        },
        resetValidation(state) {
            state.validation.errors = {};
            state.validation.message = null;
        },
        setFooterHeight(state, height) {
            state.footerHeight = height;
        },
    },

    actions: {
        obtainCsrfToken: function (context) {
            return new Promise((resolve, reject) => {
                axios.get('sanctum/csrf-cookie')
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },

        registerNewUser: function (context, payload) {
            return new Promise((resolve, reject) => {

                context.dispatch('obtainCsrfToken')
                    .then(response => {
                        authAxios.post('register', payload)
                            .then(response => resolve(response))
                            .catch(error => reject(error));
                    })
                    .catch(error => reject(error));
            });
        },

        login: function (context, payload) {
            return new Promise((resolve, reject) => {

                context.dispatch('obtainCsrfToken')
                    .then(response => {
                        authAxios.post('login', payload)
                            .then(response => resolve(response))
                            .catch(error => reject(error));
                    })
                    .catch(error => reject(error));
            });
        },

        logout: function (context, payload) {
            return new Promise((resolve, reject) => {

                context.dispatch('obtainCsrfToken')
                    .then(response => {
                        authAxios.post('logout', payload)
                            .then(response => resolve(response))
                            .catch(error => reject(error));
                    })
                    .catch(error => reject(error));
            });
        },

        verifyEmail: function (context, payload) {
            return new Promise((resolve, reject) => {

                context.dispatch('obtainCsrfToken')
                    .then(response => {
                        authAxios.get('email/verify/'+payload.id+'/'+payload.hash, {
                            params: payload.params
                        })
                            .then(response => resolve(response))
                            .catch(error => reject(error));
                    })
                    .catch(error => reject(error));
            });
        },

        sendVerificationEmail: function (context, payload) {
            return new Promise((resolve, reject) => {

                context.dispatch('obtainCsrfToken')
                    .then(response => {
                        authAxios.post('email/verification-notification/')
                            .then(response => resolve(response))
                            .catch(error => reject(error));
                    })
                    .catch(error => reject(error));
            });
        },

        sendPasswordRecoveryEmail: function (context, payload) {
            return new Promise((resolve, reject) => {

                context.dispatch('obtainCsrfToken')
                    .then(response => {
                        authAxios.post('forgot-password/', payload)
                            .then(response => resolve(response))
                            .catch(error => reject(error));
                    })
                    .catch(error => reject(error));
            });
        },

        resetPassword: function (context, payload) {
            return new Promise((resolve, reject) => {

                context.dispatch('obtainCsrfToken')
                    .then(response => {
                        authAxios.post('reset-password/', payload)
                            .then(response => resolve(response))
                            .catch(error => reject(error));
                    })
                    .catch(error => reject(error));
            });
        },

        loadOrders: function (context, payload) {
            if (context.state.sources.load_orders) {
                context.state.sources.load_orders.cancel();
            }

            context.state.sources.load_orders = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.get('orders/', {
                    cancelToken: context.state.sources.load_orders.token,
                    params: {
                        page: payload.page,
                        search_query: payload.search_query
                    },
                    paramsSerializer: params => {
                        return qs.stringify(params, {arrayFormat: 'brackets'})
                    },
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        loadGiveOuts: function (context, payload) {
            if (context.state.sources.load_give_outs) {
                context.state.sources.load_give_outs.cancel();
            }

            context.state.sources.load_give_outs = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.get('give_outs_closed/', {
                    cancelToken: context.state.sources.load_give_outs.token,
                    params: {
                        page: payload.page,
                        search_query: payload.search_query
                    },
                    paramsSerializer: params => {
                        return qs.stringify(params, {arrayFormat: 'brackets'})
                    },
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        updateGiveOutShipment: function (context, payload) {
            if (context.state.sources.update_give_out_shipment) {
                context.state.sources.update_give_out_shipment.cancel();
            }

            context.state.sources.update_give_out_shipment = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios[payload.method]('give_outs_closed/'+payload.GiveOutID+'/shipment', payload.formData, {
                    cancelToken: context.state.sources.update_give_out_shipment.token
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
            
        },
        orderClosedIndex: function (context, payload) {
            if (context.state.sources.order_closed_index) {
                context.state.sources.order_closed_index.cancel();
            }

            context.state.sources.order_closed_index = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.get('orders_closed/', {
                    cancelToken: context.state.sources.order_closed_index.token,
                    params: {
                        page: payload.page,
                        search_query: payload.search_query
                    },
                    paramsSerializer: params => {
                        return qs.stringify(params, {arrayFormat: 'brackets'})
                    },
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        loadDrafts: function (context, payload) {
            if (context.state.sources.load_drafts) {
                context.state.sources.load_drafts.cancel();
            }

            context.state.sources.load_drafts = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.get('drafts/', {
                    cancelToken: context.state.sources.load_drafts.token,
                    params: {
                        page: payload.page,
                        search_query: payload.search_query
                    },
                    paramsSerializer: params => {
                        return qs.stringify(params, {arrayFormat: 'brackets'})
                    },
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        showDraft: function (context, draftID) {
            if (context.state.sources.get_draft) {
                context.state.sources.get_draft.cancel();
            }

            context.state.sources.get_draft = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.get('drafts/'+draftID, {
                    cancelToken: context.state.sources.get_draft.token
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        draftStore: function (context, payload) {
            if (context.state.sources.draft_store) {
                context.state.sources.draft_store.cancel();
            }

            context.state.sources.draft_store = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.post('drafts', payload, {
                    cancelToken: context.state.sources.draft_store.token
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        destroyDraft: function (context, DraftID) {
            if (context.state.sources.destroy_draft) {
                context.state.sources.destroy_draft.cancel();
            }

            context.state.sources.destroy_draft = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.delete('drafts/'+DraftID, {
                    cancelToken: context.state.sources.destroy_draft.token,
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        deleteDraftedBlock: function (context, DraftedBlockID) {
            if (context.state.sources.delete_drafted_block) {
                context.state.sources.delete_drafted_block.cancel();
            }

            context.state.sources.delete_drafted_block = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.delete('drafted_blocks/'+DraftedBlockID, {
                    cancelToken: context.state.sources.delete_drafted_block.token,
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        updateDraftCustomer: function (context, payload) {
            if (context.state.sources.update_draft_customer) {
                context.state.sources.update_draft_customer.cancel();
            }

            context.state.sources.update_draft_customer = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.put('drafts/'+payload.DraftID+'/customer', payload.data, {
                    cancelToken: context.state.sources.update_draft_customer.token
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        loadSystems: function (context, payload) {
            payload = payload || {};

            if (context.state.sources.load_systems) {
                context.state.sources.load_systems.cancel();
            }

            context.state.sources.load_systems = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.get('systems/', {
                    cancelToken: context.state.sources.load_systems.token,
                    params: {
                        ...(payload.hasOwnProperty('searchQuery') ? {search_query: payload.searchQuery}: {}),
                        ...(payload.hasOwnProperty('page') ? {page: payload.page} : {}),
                        ...(payload.hasOwnProperty('allSystems') ? {all_systems: payload.allSystems} : {}),
                    },
                    paramsSerializer: params => {
                        return qs.stringify(params, {arrayFormat: 'brackets'})
                    },
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        loadSystemBlocks: function (context, SystemID) {
            if (context.state.sources.load_system_blocks) {
                context.state.sources.load_system_blocks.cancel();
            }

            context.state.sources.load_system_blocks = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.get('systems/'+SystemID+'/blocks?web_app_visible=1', {
                    cancelToken: context.state.sources.load_system_blocks.token
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        loadBlockColors: function (context, BlockID) {
            if (context.state.sources.load_block_colors) {
                context.state.sources.load_block_colors.cancel();
            }

            context.state.sources.load_block_colors = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.get('blocks/'+BlockID+'/colors', {
                    cancelToken: context.state.sources.load_block_colors.token
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        loadBlockFrontColors: function (context, BlockID) {
            if (context.state.sources.load_block_front_colors) {
                context.state.sources.load_block_front_colors.cancel();
            }

            context.state.sources.load_block_front_colors = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.get('blocks/'+BlockID+'/front_colors', {
                    cancelToken: context.state.sources.load_block_front_colors.token
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        blockComponentIndex: function (context, BlockID) {
            if (context.state.sources.block_component_index) {
                context.state.sources.block_component_index.cancel();
            }

            context.state.sources.block_component_index = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.get('blocks/'+BlockID+'/components', {
                    cancelToken: context.state.sources.block_component_index.token
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        blockComponentColorIndex: function (context, payload) {
            if (context.state.sources.block_component_color_index) {
                context.state.sources.block_component_color_index.cancel();
            }

            context.state.sources.block_component_color_index = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.get('blocks/'+payload.BlockID+'/components/'+payload.ComponentID+'/colors', {
                    cancelToken: context.state.sources.block_component_color_index.token
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        storeOrderedBlocks: function (context, payload) {
            if (context.state.sources.store_drafted_blocks) {
                context.state.sources.store_drafted_blocks.cancel();
            }

            context.state.sources.store_drafted_blocks = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.post('drafted_blocks', payload, {
                    cancelToken: context.state.sources.store_drafted_blocks.token
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        orderShow: function (context, orderID) {
            if (context.state.sources.order_show) {
                context.state.sources.order_show.cancel();
            }

            context.state.sources.order_show = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.get('orders/'+orderID, {
                    cancelToken: context.state.sources.order_show.token
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        orderClosedShow: function (context, orderID) {
            if (context.state.sources.order_closed_show) {
                context.state.sources.order_closed_show.cancel();
            }

            context.state.sources.order_closed_show = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.get('orders_closed/'+orderID, {
                    cancelToken: context.state.sources.order_closed_show.token
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        orderStore: function (context, payload) {
            if (context.state.sources.order_store) {
                context.state.sources.order_store.cancel();
            }

            context.state.sources.order_store = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.post('orders', payload, {
                    cancelToken: context.state.sources.order_store.token
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        orderUpdate: function (context, payload) {
            if (context.state.sources.order_update) {
                context.state.sources.order_update.cancel();
            }

            context.state.sources.order_update = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.put('orders', payload, {
                    cancelToken: context.state.sources.order_update.token
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        orderDelete: function (context, OrderID) {
            if (context.state.sources.order_delete) {
                context.state.sources.order_delete.cancel();
            }

            context.state.sources.order_delete = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.delete('orders/'+OrderID, {
                    cancelToken: context.state.sources.order_delete.token,
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        shipmentTypeIndex: function (context) {
            if (context.state.sources.shipment_type_index) {
                context.state.sources.shipment_type_index.cancel();
            }

            context.state.sources.shipment_type_index = axios.CancelToken.source();
            return new Promise((resolve, reject) => {
                apiAxios.get('shipment_types/', {
                    cancelToken: context.state.sources.shipment_type_index.token
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        reclamationIndex: function (context, payload) {
            if (context.state.sources.reclamation_index) {
                context.state.sources.reclamation_index.cancel();
            }

            context.state.sources.reclamation_index = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.get('reclamations/', {
                    cancelToken: context.state.sources.reclamation_index.token,
                    params: {page: payload.page},
                    paramsSerializer: params => {
                        return qs.stringify(params, {arrayFormat: 'brackets'})
                    },
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        reclamationStore: function (context, payload) {
            if (context.state.sources.reclamation_store) {
                context.state.sources.reclamation_store.cancel();
            }

            context.state.sources.reclamation_store = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.post('reclamations', payload, {
                    cancelToken: context.state.sources.reclamation_store.token
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        reclamationUpdate: function (context, payload) {
            if (context.state.sources.reclamation_update) {
                context.state.sources.reclamation_update.cancel();
            }

            context.state.sources.reclamation_update = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.put('reclamations/'+payload.ReclamationID, payload.formData, {
                    cancelToken: context.state.sources.reclamation_update.token
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        reclamationDelete: function (context, ReclamationID) {
            if (context.state.sources.reclamation_delete) {
                context.state.sources.reclamation_delete.cancel();
            }

            context.state.sources.reclamation_delete = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.delete('reclamations/'+ReclamationID, {
                    cancelToken: context.state.sources.reclamation_delete.token,
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },

        tokenIndex: function (context) {
            if (context.state.sources.token_index) {
                context.state.sources.token_index.cancel();
            }

            context.state.sources.token_index = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.get('client/personal_access_tokens/', {
                    cancelToken: context.state.sources.token_index.token,
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        tokenStore: function (context, payload) {
            if (context.state.sources.token_store) {
                context.state.sources.token_store.cancel();
            }

            context.state.sources.token_store = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.post('client/personal_access_tokens', payload, {
                    cancelToken: context.state.sources.token_store.token
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        tokenDelete: function (context, tokenId) {
            if (context.state.sources.token_delete) {
                context.state.sources.token_delete.cancel();
            }

            context.state.sources.token_delete = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.delete('client/personal_access_tokens/'+tokenId, {
                    cancelToken: context.state.sources.token_delete.token,
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },

        reclamationReasonIndex: function (context) {
            if (context.state.sources.reclamation_reason_index) {
                context.state.sources.reclamation_reason_index.cancel();
            }

            context.state.sources.reclamation_reason_index = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.get('reclamation_reasons/', {
                    cancelToken: context.state.sources.reclamation_reason_index.token
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },

        clientIndex: function (context, payload) {
            payload = payload || {};

            if (context.state.sources.client_index) {
                context.state.sources.client_index.cancel();
            }

            context.state.sources.client_index = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.get('clients/', {
                    cancelToken: context.state.sources.client_index.token,
                    params: {
                        ...{search_query: payload.search_query},
                        ...(payload.hasOwnProperty('page') ? {page: payload.page} : {}),
                    },
                    paramsSerializer: params => {
                        return qs.stringify(params, {arrayFormat: 'brackets'})
                    },
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        clientPasswordUpdate: function (context, payload) {
            if (context.state.sources.client_password_update) {
                context.state.sources.client_password_update.cancel();
            }

            context.state.sources.client_password_update = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.put('client/password/', payload, {
                    cancelToken: context.state.sources.client_password_update.token
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },

        clientShow: function (context) {
            if (context.state.sources.client_show) {
                context.state.sources.client_show.cancel();
            }

            context.state.sources.client_show = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.get('client/', {
                    cancelToken: context.state.sources.client_show.token
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },

        clientUpdate: function (context, payload) {
            if (context.state.sources.client_update) {
                context.state.sources.client_update.cancel();
            }

            context.state.sources.client_update = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.put('client/', payload, {
                    cancelToken: context.state.sources.client_update.token
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },

        clientDetailUpdate: function (context, payload) {
            if (context.state.sources.client_detail_update) {
                context.state.sources.client_detail_update.cancel();
            }

            context.state.sources.client_detail_update = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.put('client/details/', payload, {
                    cancelToken: context.state.sources.client_detail_update.token
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        invitedClientStore: function (context, payload) {
            if (context.state.sources.invited_client_store) {
                context.state.sources.invited_client_store.cancel();
            }

            context.state.sources.invited_client_store = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.post('clients/'+payload.ClientID+'/invite', payload.formData, {
                    cancelToken: context.state.sources.invited_client_store.token
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },

        countryIndex: function (context) {
            if (context.state.sources.country_index) {
                context.state.sources.country_index.cancel();
            }

            context.state.sources.country_index = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.get('countries/', {
                    cancelToken: context.state.sources.country_index.token
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        providenceIndex: function (context) {
            if (context.state.sources.providence_index) {
                context.state.sources.providence_index.cancel();
            }

            context.state.sources.providence_index = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.get('providences/', {
                    cancelToken: context.state.sources.providence_index.token
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        cityIndex: function (context) {
            if (context.state.sources.city_index) {
                context.state.sources.city_index.cancel();
            }

            context.state.sources.city_index = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.get('cities/', {
                    cancelToken: context.state.sources.city_index.token
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        activeMessageIndex: function (context) {
            if (context.state.sources.active_message_index) {
                context.state.sources.active_message_index.cancel();
            }

            context.state.sources.active_message_index = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.get('messages/active/', {
                    cancelToken: context.state.sources.active_message_index.token
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        messageIndex: function (context) {
            if (context.state.sources.message_index) {
                context.state.sources.message_index.cancel();
            }

            context.state.sources.message_index = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.get('messages/', {
                    cancelToken: context.state.sources.message_index.token
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        messageStore: function (context, payload) {
            if (context.state.sources.message_store) {
                context.state.sources.message_store.cancel();
            }

            context.state.sources.message_store = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.post('messages/', payload, {
                    cancelToken: context.state.sources.message_store.token
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        messageUpdate: function (context, payload) {
            if (context.state.sources.message_update) {
                context.state.sources.message_update.cancel();
            }

            context.state.sources.message_update = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.put('messages/'+payload.MessageID, payload.formData, {
                    cancelToken: context.state.sources.message_update.token
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        messageDelete: function (context, MessageID) {
            if (context.state.sources.message_delete) {
                context.state.sources.message_delete.cancel();
            }

            context.state.sources.message_delete = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.delete('messages/'+MessageID, {
                    cancelToken: context.state.sources.message_delete.token,
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        tagIndex: function (context) {
            if (context.state.sources.tag_index) {
                context.state.sources.tag_index.cancel();
            }

            context.state.sources.tag_index = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.get('tags/', {
                    cancelToken: context.state.sources.tag_index.token
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        tagStore: function (context, payload) {
            if (context.state.sources.tag_store) {
                context.state.sources.tag_store.cancel();
            }

            context.state.sources.tag_store = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.post('tags/', payload, {
                    cancelToken: context.state.sources.tag_store.token
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        tagUpdate: function (context, payload) {
            if (context.state.sources.tag_update) {
                context.state.sources.tag_update.cancel();
            }

            context.state.sources.tag_update = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.put('tags/'+payload.TagID, payload.formData, {
                    cancelToken: context.state.sources.tag_update.token
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        tagDelete: function (context, TagID) {
            if (context.state.sources.tag_delete) {
                context.state.sources.tag_delete.cancel();
            }

            context.state.sources.tag_delete = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.delete('tags/'+TagID, {
                    cancelToken: context.state.sources.tag_delete.token,
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        systemImageStore: function (context, payload) {
            if (context.state.sources.system_image_store) {
                context.state.sources.system_image_store.cancel();
            }

            context.state.sources.system_image_store = axios.CancelToken.source();

            let formData = new FormData();
            for (const [key, value] of Object.entries(payload.formData)) {
                formData.append(key, value);
            }

            return new Promise((resolve, reject) => {
                apiAxios.post('systems/'+payload.SystemID+'/image', formData, {
                    cancelToken: context.state.sources.system_image_store.token,
                    headers: {'Content-Type': 'multipart/form-data'},
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        systemImageDelete: function (context, SystemID) {
            if (context.state.sources.system_image_delete) {
                context.state.sources.system_image_delete.cancel();
            }

            context.state.sources.system_image_delete = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.delete('systems/'+SystemID+'/image', {
                    cancelToken: context.state.sources.system_image_delete.token,
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        blockIndex: function (context, payload) {
            payload = payload || {};

            if (context.state.sources.block_index) {
                context.state.sources.block_index.cancel();
            }

            context.state.sources.block_index = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.get('blocks/', {
                    cancelToken: context.state.sources.block_index.token,
                    params: {
                        ...(payload.hasOwnProperty('searchQuery') ? {search_query: payload.searchQuery}: {}),
                        ...(payload.hasOwnProperty('page') ? {page: payload.page} : {}),
                        ...(payload.hasOwnProperty('systemId') ? {system_id: payload.systemId} : {}),
                    },
                    paramsSerializer: params => {
                        return qs.stringify(params, {arrayFormat: 'brackets'})
                    },
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        blockUpdate: function (context, payload) {
            if (context.state.sources.block_update) {
                context.state.sources.block_update.cancel();
            }

            context.state.sources.block_update = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.put('blocks/'+payload.BlockID, payload.formData, {
                    cancelToken: context.state.sources.block_update.token,
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        blockInstructionStore: function (context, payload) {
            if (context.state.sources.block_instruction_store) {
                context.state.sources.block_instruction_store.cancel();
            }

            context.state.sources.block_instruction_store = axios.CancelToken.source();

            let formData = new FormData();
            for (const [key, value] of Object.entries(payload.formData)) {
                formData.append(key, value);
            }

            return new Promise((resolve, reject) => {
                apiAxios.post('blocks/'+payload.BlockID+'/instruction', formData, {
                    cancelToken: context.state.sources.block_instruction_store.token,
                    headers: {'Content-Type': 'multipart/form-data'},
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        blockInstructionDelete: function (context, BlockID) {
            if (context.state.sources.block_instruction_delete) {
                context.state.sources.block_instruction_delete.cancel();
            }

            context.state.sources.block_instruction_delete = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.delete('blocks/'+BlockID+'/instruction', {
                    cancelToken: context.state.sources.block_instruction_delete.token,
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        colorIndex: function (context, payload) {
            payload = payload || {};

            if (context.state.sources.color_index) {
                context.state.sources.color_index.cancel();
            }

            context.state.sources.color_index = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.get('colors', {
                    cancelToken: context.state.sources.color_index.token,
                    params: {
                        ...{include_archived: 1},
                        ...(payload.hasOwnProperty('searchQuery') ? {search_query: payload.searchQuery}: {}),
                        ...(payload.hasOwnProperty('page') ? {page: payload.page} : {}),
                    },
                    paramsSerializer: params => {
                        return qs.stringify(params, {arrayFormat: 'brackets'})
                    },
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        colorImageStore: function (context, payload) {
            if (context.state.sources.color_image_store) {
                context.state.sources.color_image_store.cancel();
            }

            context.state.sources.color_image_store = axios.CancelToken.source();

            let formData = new FormData();
            for (const [key, value] of Object.entries(payload.formData)) {
                formData.append(key, value);
            }

            return new Promise((resolve, reject) => {
                apiAxios.post('colors/'+payload.UnitColorID+'/image', formData, {
                    cancelToken: context.state.sources.color_image_store.token,
                    headers: {'Content-Type': 'multipart/form-data'},
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        colorImageDelete: function (context, UnitColorID) {
            if (context.state.sources.color_image_delete) {
                context.state.sources.color_image_delete.cancel();
            }

            context.state.sources.color_image_delete = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.delete('colors/'+UnitColorID+'/image', {
                    cancelToken: context.state.sources.color_image_delete.token,
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        packageIndex: function (context, payload) {
            payload = payload || {};

            if (context.state.sources.package_index) {
                context.state.sources.package_index.cancel();
            }

            context.state.sources.package_index = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.get('packages/', {
                    cancelToken: context.state.sources.package_index.token,
                    params: {
                        ...{include_archived: 1},
                        ...(payload.hasOwnProperty('searchQuery') ? {search_query: payload.searchQuery}: {}),
                        ...(payload.hasOwnProperty('page') ? {page: payload.page} : {}),
                        ...(payload.hasOwnProperty('systemId') ? {system_id: payload.systemId} : {}),
                        ...(payload.hasOwnProperty('blockId') ? {block_id: payload.blockId} : {}),
                        ...(payload.hasOwnProperty('tagIds') ? {tag_ids: payload.tagIds} : {}),
                    },
                    paramsSerializer: params => {
                        return qs.stringify(params, {arrayFormat: 'brackets'})
                    },
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        packageUpdate: function (context, payload) {
            if (context.state.sources.package_update) {
                context.state.sources.package_update.cancel();
            }

            context.state.sources.package_update = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.put('packages/'+payload.PackageID, payload.formData, {
                    cancelToken: context.state.sources.package_update.token,
                    params: {
                        ...{include_archived: 1},
                    },
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        packageImageStore: function (context, payload) {
            if (context.state.sources.package_image_store) {
                context.state.sources.package_image_store.cancel();
            }

            context.state.sources.package_image_store = axios.CancelToken.source();

            let formData = new FormData();
            for (const [key, value] of Object.entries(payload.formData)) {
                if (Array.isArray(value)) {
                    value.forEach(v => {
                        formData.append(`${key}[]`, v);
                    });
                } else {
                    formData.append(key, value);
                }
            }

            return new Promise((resolve, reject) => {
                apiAxios.post('packages/'+payload.PackageID+'/images', formData, {
                    cancelToken: context.state.sources.package_image_store.token,
                    headers: {'Content-Type': 'multipart/form-data'},
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        packageImageDelete: function (context, PackageImageID) {
            if (context.state.sources.package_image_delete) {
                context.state.sources.package_image_delete.cancel();
            }

            context.state.sources.package_image_delete = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.delete('package_images/'+PackageImageID, {
                    cancelToken: context.state.sources.package_image_delete.token,
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        packageDefaultImageUpdate: function (context, PackageImageID) {
            if (context.state.sources.package_default_image_update) {
                context.state.sources.package_default_image_update.cancel();
            }

            context.state.sources.package_default_image_update = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.post('package_images/'+PackageImageID+'/default', {
                    cancelToken: context.state.sources.package_default_image_update.token,
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        packageStockLevelsExport: function (context, payload) {
            if (context.state.sources.package_stock_levels_export) {
                context.state.sources.package_stock_levels_export.cancel();
            }

            context.state.sources.package_stock_levels_export = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.post('products_export_urls', payload, {
                    cancelToken: context.state.sources.package_stock_levels_export.token,
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        distributorIndex: function (context) {
            if (context.state.sources.distributor_index) {
                context.state.sources.distributor_index.cancel();
            }

            context.state.sources.distributor_index = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.get('distributors/', {
                    cancelToken: context.state.sources.distributor_index.token
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        webAppUserEmailUpdate: function (context, payload) {
            if (context.state.sources.web_app_user_email_update) {
                context.state.sources.web_app_user_email_update.cancel();
            }

            context.state.sources.web_app_user_email_update = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.put('web_app_users/'+payload.userId+'/email', payload.formData, {
                    cancelToken: context.state.sources.web_app_user_email_update.token
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        webAppUserEmailVerifiedAtUpdate: function (context, userId) {
            return new Promise((resolve, reject) => {
                apiAxios.put('web_app_users/'+userId+'/email_verified_at/')
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        webAppUserDelete: function (context, userId) {
            if (context.state.sources.web_app_user_delete) {
                context.state.sources.web_app_user_delete.cancel();
            }

            context.state.sources.web_app_user_delete = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.delete('web_app_users/'+userId, {
                    cancelToken: context.state.sources.web_app_user_delete.token
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        unitIndex: function (context, payload) {
            if (context.state.sources.unit_index) {
                context.state.sources.unit_index.cancel();
            }

            context.state.sources.unit_index = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.get('units/', {
                    cancelToken: context.state.sources.unit_index.token,
                    params: {
                        page: payload.page,
                        search_query: payload.search_query,
                        missing_only: payload.missing_only,
                    },
                    paramsSerializer: params => {
                        return qs.stringify(params, {arrayFormat: 'brackets'})
                    },
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        unitAvailabilityDateUpdate: function (context, payload) {
            if (context.state.sources.unit_availability_date_update) {
                context.state.sources.unit_availability_date_update.cancel();
            }

            context.state.sources.unit_availability_date_update = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.put('units/'+payload.UnitId+'/availability_date', payload.formData, {
                    cancelToken: context.state.sources.unit_availability_date_update.token
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        unitAvailabilityDateBulkUpdate: function (context, payload) {
            if (context.state.sources.unit_availability_date_bulk_update) {
                context.state.sources.unit_availability_date_bulk_update.cancel();
            }

            context.state.sources.unit_availability_date_bulk_update = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.put('units/bulk/availability_date', payload, {
                    cancelToken: context.state.sources.unit_availability_date_bulk_update.token
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        systemClientStore: function (context, payload) {
            if (context.state.sources.system_client_store) {
                context.state.sources.system_client_store.cancel();
            }

            context.state.sources.system_client_store = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.post('systems/' + payload.System.SystemID + '/clients', {
                    ClientID: payload.ClientID
                }, {
                    cancelToken: context.state.sources.system_client_store.token
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        clientSystemDestroy: function (context, payload) {
            if (context.state.sources.client_system_destroy) {
                context.state.sources.client_system_destroy.cancel();
            }

            context.state.sources.client_system_destroy = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.delete('client_systems/' + payload.ClientSystem.ClientSystemID, {
                    cancelToken: context.state.sources.client_system_destroy.token
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        userIndex: function (context, payload) {
            payload = payload || {};

            if (context.state.sources.user_index) {
                context.state.sources.user_index.cancel();
            }

            context.state.sources.user_index = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.get('users/', {
                    cancelToken: context.state.sources.user_index.token,
                    params: {
                        ...(payload.hasOwnProperty('search_query') ? {search_query: payload.search_query} : {}),
                        ...(payload.hasOwnProperty('date_from') && payload.date_from !== null
                            ? {date_from: payload.date_from}
                            : {}
                        ),
                        ...(payload.hasOwnProperty('date_to') && payload.date_to !== null
                            ? {date_to: payload.date_to}
                            : {}
                        ),
                    },
                    paramsSerializer: params => {
                        return qs.stringify(params, {arrayFormat: 'brackets'})
                    },
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        userQrCodeIndex: function (context, UserID) {
            if (context.state.sources.user_qr_code_index) {
                context.state.sources.user_qr_code_index.cancel();
            }

            context.state.sources.user_show = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.get('users/' + UserID + '/qr_code', {
                    cancelToken: context.state.sources.user_qr_code_index.token
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        userStore: function (context, payload) {
            if (context.state.sources.user_store) {
                context.state.sources.user_store.cancel();
            }

            context.state.sources.user_store = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.post('users/', payload, {
                    cancelToken: context.state.sources.user_store.token
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        userShow: function (context, UserID) {
            if (context.state.sources.user_show) {
                context.state.sources.user_show.cancel();
            }

            context.state.sources.user_show = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.get('users/' + UserID, {
                    cancelToken: context.state.sources.user_show.token
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        userUpdate: function (context, payload) {
            if (context.state.sources.user_update) {
                context.state.sources.user_update.cancel();
            }

            context.state.sources.user_update = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.put('users/' + payload.UserID, payload.formData, {
                    cancelToken: context.state.sources.user_update.token
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        userPasswordUpdate: function (context, payload) {
            if (context.state.sources.user_password_update) {
                context.state.sources.user_password_update.cancel();
            }

            context.state.sources.user_password_update = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.put('users/' + payload.UserID + '/password', payload.formData, {
                    cancelToken: context.state.sources.user_password_update.token
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        userDestroy: function (context, UserID) {
            if (context.state.sources.user_destroy) {
                context.state.sources.user_destroy.cancel();
            }

            context.state.sources.user_destroy = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.delete('users/' + UserID, {
                    cancelToken: context.state.sources.user_destroy.token
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        userRolesIndex: function (context) {
            if (context.state.sources.user_role_index) {
                context.state.sources.user_role_index.cancel();
            }

            context.state.sources.user_role_index = axios.CancelToken.source();

            return new Promise((resolve, reject) => {
                apiAxios.get('user-roles/', {
                    cancelToken: context.state.sources.user_role_index.token
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
    },
})
